export const ACTIVE_USERS_DEFAULT_WINDOW_DAYS = 30;

export interface ActiveUsersWindowOption {
  label: string;
  value: number;
}

/** Ventanas móviles estándar: DAU / WAU / MAU, en el lenguaje del negocio. */
export const ACTIVE_USERS_WINDOW_OPTIONS: ActiveUsersWindowOption[] = [
  { label: "1 día (diarios)", value: 1 },
  { label: "7 días (semanales)", value: 7 },
  { label: "30 días (mensuales)", value: 30 },
  { label: "90 días (trimestrales)", value: 90 },
];

/** Fecha de corte por defecto: hoy. */
export const defaultActiveUsersCutoffDate = (): Date => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  return date;
};

/**
 * "YYYY-MM-DD" en hora local del navegador. El corte es un día calendario, no un instante:
 * usar toISOString() acá correría la fecha para cualquier navegador al oeste de UTC.
 */
export const toActiveUsersDayParam = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`;

/**
 * Primer día de la ventana, inclusive. La ventana de N días TERMINA en la fecha de corte,
 * así que arranca N-1 días antes: con N=1 arranca y termina el mismo día.
 */
export const activeUsersWindowStart = (cutoff: Date, windowDays: number): Date => {
  const start = new Date(cutoff);
  start.setHours(0, 0, 0, 0);
  start.setDate(start.getDate() - (windowDays - 1));
  return start;
};

const formatDayLabel = (date: Date): string =>
  `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}/${date.getFullYear()}`;

export const formatActiveUsersWindowLabel = (
  cutoff: Date,
  windowDays: number
): string => {
  if (windowDays === 1) {
    return formatDayLabel(cutoff);
  }
  return `${formatDayLabel(activeUsersWindowStart(cutoff, windowDays))} y el ${formatDayLabel(
    cutoff
  )}`;
};
